import type { FC } from 'react';
import { useEffect, useRef } from 'react';

import styles from './BorderTimer.module.css';

export interface BorderTimerProps {
  /** duration of the timer in miliseconds */
  duration: number;
  /** callback to execute when timer elapses */
  onTimerEnd?: () => void;
}

export const BorderTimer: FC<BorderTimerProps> = ({ duration, onTimerEnd }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!wrapperRef.current) return;
    wrapperRef.current.style.setProperty('--duration', `${Math.floor(duration / 2)}ms`);
  }, [duration]);

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <div className={`${styles.half_ctn} ${styles.half_ctn__left}`}>
        <div className={styles.ctn_inner}>
          <div className={styles.border} />
        </div>
      </div>
      <div className={`${styles.half_ctn} ${styles.half_ctn__right}`} onAnimationEnd={onTimerEnd}>
        <div className={styles.ctn_inner}>
          <div className={styles.border} />
        </div>
      </div>
    </div>
  );
};
